import { useState } from 'react';
import { bool, string, func } from 'prop-types';
import AddIcon from 'imagesUwKluis/svg/addfill.svg';
import Box from '../../shared/layouts/Box';
import Flex from '../../shared/layouts/Flex';
import Button from '../../shared/Button';
import Stack from '../../shared/layouts/Stack';
import Input from '../../shared/Input';
import {useTranslation} from "react-i18next";
import i18n from "../../../i18n";

const VerificationCodeForm = ({
  organization = i18n.t('je adviseur'),
  phone_number = i18n.t('onbekend'),
  onResend = () => {},
  onSubmit = () => {},
  infoText = null,
  error = null,
  disableButtons = false,
  hideResendButton = false,
}) => {
  const [code, setCode] = useState(Array(6).fill(''));
  const { t } = useTranslation();

  const handlePaste = (e) => {
    const pasted = (e.target.value || '').replace(/\s/g, '');
    if (pasted.length === 6) {
      setCode(pasted.split('').slice(0, 6));
      e.target.parentElement.parentElement.lastElementChild.children[0].focus();
    }
  };

  return (
    <Stack space="m" m="auto">
      <Flex width="100%" justifyContent="center" my="xl">
        <AddIcon
          css={(theme) => ({
            fill: theme?.colors?.primary,
            width: '96px',
            height: '96px',
          })}
        />
      </Flex>
      <Box textAlign="center" fontScale="xl">
        {t('Voer je code in')}
      </Box>
      <Box textAlign="center">
        {infoText ?? t(
          'We stuurden ter contole een code naar {{phone_number}}. Vul deze code hier in om de koppeling met {{organization}} te bevestigen.',
          { phone_number, organization }
        )}
      </Box>
      <Flex
        bg="background"
        justifyContent="center"
        alignItems="center"
        margin={{ mobile: '32px -16px', desktop: '32px -32px' }}
        padding={{ mobile: '24px 16px', desktop: '24px' }}
        css={{
          '> * + *': {
            marginLeft: '16px',
          },
        }}
      >
        {code.map((value, i) => (
          <Input
            key={i}
            value={value}
            type="tel"
            css={{
              width: '40px',
              '> input': {
                textAlign: 'center',
              },
            }}
            onChange={(e) => {
              if (i === 0 && e.target.value.length >= 6) {
                handlePaste(e);
              } else {
                const nextInput = e.target.parentElement.nextSibling;
                setCode([
                  ...code.slice(0, i),
                  e.target.value.substring(0, 1),
                  ...code.slice(i + 1),
                ]);
                if (!value && nextInput) nextInput.children[0].focus();
              }
            }}
            onKeyDown={({ key, target }) => {
              if (
                key === 'Backspace' &&
                target.selectionStart === 0 &&
                target.selectionEnd === 0
              ) {
                const previousInput = target.parentElement.previousSibling;
                if (previousInput) previousInput.children[0].focus();
              }
            }}
          />
        ))}
      </Flex>
      {error && (
        <Box textAlign="center">
          {error}
        </Box>
      )}
      <Flex
        justifyContent="flex-end"
        mt="4xl"
        css={{ '> * + *': { marginLeft: '16px' } }}
      >
        {!hideResendButton && (
          <Button disabled={disableButtons} onClick={onResend} variant="primary-outline">
            {t('SMS opnieuw versturen')}
          </Button>
        )}
        <Button disabled={disableButtons} onClick={() => onSubmit(code.join(''))}>
          {t('Bevestigen')}
        </Button>
      </Flex>
    </Stack>
  );
};

VerificationCodeForm.propTypes = {
  organization: string,
  phone_number: string,
  onResend: func,
  onSubmit: func,
  infoText: string,
  error: string,
  disableButtons: bool,
  hideResendButton: bool,
};

export default VerificationCodeForm;
